import { ReactNode, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

interface Props {
  children: ReactNode;
  flush?: boolean;
}

export default function Layout({ children, flush = false }: Props) {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <Navbar />
      <main className={`flex-1 ${flush ? "" : "pt-16 md:pt-[72px]"}`}>{children}</main>
      <Footer />
    </div>
  );
}